import axios from "axios";
import { API_URL } from "../../../utils/constants"; // Adjust path if needed

export const getAzureMetricsLogsApi = async (param, selectedService, provider) => {
  try {
    console.log("API Call - Selected Service:", selectedService);
    console.log("API Call - Params:", param);

    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/compute-metrics" : selectedService;
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`, // Dynamic service in the URL
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      params: param,
    });

    console.log("API Response:", response);
    return response;
  } catch (e) {
    console.error("API Error:", e);
    return [];
  }
};
